export default {"src":"/_next/static/media/green-text-logo.97276f50.svg","height":100,"width":347};